export const COOKIE_CONSENT_NAME = 'cookie_alert_submited';
export const CONNECTING_IP_HEADER_NAME = 'cf-connecting-ip';
export const CONNECTING_COUNTRY_CODE_HEADER_NAME = 'cf-ipcountry';
export const CF_RAY_HEADER_NAME = 'cf-ray';
export const AMAZON_TRACE_HEADER_NAME = 'x-amzn-trace-id';
export const COUNTRY_CODE_COOKIE_NAME = '_du_country_code';

export const ELY_CONNECTING_IP_HEADER_NAME = 'ely-connecting-ip';
export const ELY_CONNECTING_COUNTRY_CODE_HEADER_NAME = 'ely-ipcountry';
export const ELY_CF_RAY_HEADER_NAME = 'ely-ray';
export const ELY_TRACE_HEADER_NAME = 'ely-trace-id';

export const APP_VERSION_HEADER_NAME = 'App-Version';
